import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/contexts/CartContext";
import Navigation from "@/components/Navigation";
import CartDrawer from "@/components/CartDrawer";
import ScrollToTopButton from "@/components/ScrollToTopButton";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ColoringPages from "@/pages/ColoringPages";
import SuccessPage from "@/pages/SuccessPage";

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Navigation />
          <CartDrawer />
          <ScrollToTopButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/coloring-pages" element={<ColoringPages />} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </CartProvider>
  );
}

export default App;
